/* Resolve current elements on each event so the theme editor can replace them. */
(function () {
  if (window.tepThemeReady) return;
  window.tepThemeReady = true;

  function closeMenu(restoreFocus) {
    var button = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-nav]');
    if (menu) menu.classList.remove('is-open');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
      if (restoreFocus) button.focus();
    }
    document.body.classList.remove('menu-open');
  }

  function updateHeader() {
    var header = document.querySelector('[data-site-header]');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  }

  function activateTab(button) {
    var tabs = button.closest('[data-tabs]');
    if (!tabs) return;
    tabs.querySelectorAll('[role="tab"]').forEach(function (item) {
      var selected = item === button;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', String(selected));
    });
    tabs.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      var selected = panel.id === button.getAttribute('aria-controls');
      panel.classList.toggle('is-active', selected);
      panel.hidden = !selected;
    });
  }

  document.addEventListener('click', function (event) {
    if (window.Shopify && window.Shopify.inspectMode) return;
    var toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      return;
    }
    if (event.target.closest('[data-mobile-nav] a')) closeMenu(false);
    var tab = event.target.closest('[data-tabs] [role="tab"]');
    if (tab) activateTab(tab);
  });
  document.addEventListener('keydown', function (event) {
    var nav = document.querySelector('[data-mobile-nav]');
    if (event.key === 'Escape' && nav && nav.classList.contains('is-open')) closeMenu(true);
    var tab = event.target.closest('[data-tabs] [role="tab"]');
    if (!tab || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    var buttons = Array.prototype.slice.call(tab.closest('[data-tabs]').querySelectorAll('[role="tab"]'));
    var step = event.key === 'ArrowRight' ? 1 : -1;
    var next = buttons[(buttons.indexOf(tab) + step + buttons.length) % buttons.length];
    event.preventDefault();
    next.focus();
    activateTab(next);
  });
  window.addEventListener('scroll', updateHeader, {passive: true});
  document.addEventListener('shopify:section:load', updateHeader);
  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(function () {
      if (!document.querySelector('[data-mobile-nav].is-open')) document.body.classList.remove('menu-open');
    }, 0);
  });
  updateHeader();
})();
